import { GB, DE, ES, FR } from "country-flag-icons/react/3x2";
import { cn, LocaleSelector } from "@cmde/shadcn";
import { useTranslation } from "react-i18next";

/** Mobile sidebar sheet uses z-[60]; select menu must stack above it. */
export const MOBILE_SIDEBAR_LOCALE_MENU_CLASS = "z-[70] w-full";

const locales = [
  { code: "en", label: "English", icon: GB },
  { code: "de", label: "Deutsch", icon: DE },
  { code: "es", label: "Español", icon: ES },
  { code: "fr", label: "Français", icon: FR },
];

type AppLocaleSelectorProps = {
  className?: string;
  contentClassName?: string;
  /** Use in the sidebar `mobileSlot` so the menu appears above the mobile sheet. */
  inMobileSidebar?: boolean;
};

export function AppLocaleSelector({
  className = "bg-none",
  contentClassName,
  inMobileSidebar = false,
}: AppLocaleSelectorProps) {
  const { i18n, t } = useTranslation();
  const language = (i18n.resolvedLanguage ?? i18n.language).split("-")[0];

  return (
    <LocaleSelector
      value={language}
      onChange={(code) => {
        void i18n.changeLanguage(code);
      }}
      locales={locales}
      placeholder={t("common.selectLanguage")}
      className={cn(inMobileSidebar && "w-full", className)}
      contentClassName={cn(
        inMobileSidebar && MOBILE_SIDEBAR_LOCALE_MENU_CLASS,
        contentClassName,
      )}
    />
  );
}
